// Fabric properties, persisted in Fabric objects

export const ANGLE = 'angle';
export const ARROW_1 = 'arrow1';
export const ARROW_2 = 'arrow2';
export const BLENDING_MODE = 'globalCompositeOperation';
export const BLUR = 'blur';
export const BORDER_RADIUS = 'borderRadius';
export const BORDER_RADIUS_X = 'rx';
export const BORDER_RADIUS_Y = 'ry';
export const BRIGHTNESS = 'brightness';
export const CHAR_SPACING = 'charSpacing';
export const CONTRAST = 'contrast';
export const CROP_X = 'cropX';
export const CROP_Y = 'cropY';
export const FILL = 'fill';
export const FLIP_X = 'flipX';
export const FLIP_Y = 'flipY';
export const FONT_FAMILY = 'fontFamily';
export const FONT_SIZE = 'fontSize';
export const FONT_STYLE = 'fontStyle';
export const FONT_WEIGHT = 'fontWeight';
export const HEIGHT = 'height';
export const INVERT = 'invert';
export const INNER_STROKE = 'innerStroke';
export const INNER_STROKE_WIDTH = 'innerStrokeWidth';
export const LEFT = 'left';
export const LENGTH = 'length';
export const LINE_HEIGHT = 'lineHeight';
export const LOCKED = 'ludus.locked';
export const OPACITY = 'opacity';
export const PERPIXELTARGETFIND = 'perPixelTargetFind';
export const SATURATION = 'saturation';
export const SCALE = 'scale';
export const SCALE_X = 'scaleX';
export const SKEW_X = 'skewX';
export const SKEW_Y = 'skewY';
export const SCALE_Y = 'scaleY';
export const SHADOW = 'shadow';
export const SHADOW_BLUR = 'shadow.blur';
export const SHADOW_COLOR = 'shadow.color';
export const SHADOW_OFFSET_X = 'shadow.offsetX';
export const SHADOW_OFFSET_Y = 'shadow.offsetY';
export const SPECIAL_APPLY_SCALE = 'ludus.applyScale';
export const SPECIAL_AUTOPLAY = 'ludus.autoplay';
export const SPECIAL_AUTOSPIN = 'ludus.autospin';
export const SPECIAL_BACKGROUND_OPACITY = 'ludus.backgroundOpacity';
export const SPECIAL_CAMERA = 'ludus.camera';
export const SPECIAL_CONTROLS = 'ludus.controls';
export const SPECIAL_DEFAULT_TAB = 'ludus.defaultTab';
export const SPECIAL_DELAY = 'ludus.delay';
export const SPECIAL_END_TIME = 'ludus.endTime';
export const SPECIAL_HIGH_QUALITY = 'ludus.highQuality';
export const SPECIAL_HIDE_FOOTER = 'ludus.hideFooter';
export const SPECIAL_HIDE_HEADERS = 'ludus.hideHeaders';
export const SPECIAL_HYPERLINK = 'ludus.hyperlink';
export const SPECIAL_LOOP = 'ludus.loop';
export const SPECIAL_MAP_TYPE = 'ludus.mapType';
export const SPECIAL_MUTE = 'ludus.mute';
export const SPECIAL_REFERENCE = 'ludus.reference';
export const SPECIAL_REVERSE = 'ludus.reverse';
export const SPECIAL_SPEED = 'ludus.speed';
export const SPECIAL_START_TIME = 'ludus.startTime';
export const SPECIAL_THEME = 'ludus.theme';
export const SPECIAL_TRANSPARENT = 'ludus.transparent';
export const SPECIAL_URL = 'ludus.url';
export const SPECIAL_ZOOM = 'ludus.zoom';
export const STROKE = 'stroke';
export const STROKE_WIDTH = 'strokeWidth';
export const STROKE_DASH = 'strokeDashArray';
export const TEXT_ALIGN = 'textAlign';
export const ARROWSIZE = 'arrowSize';
export const TINT = 'tint';
export const TOP = 'top';
export const WIDTH = 'width';
export const X1 = 'x1';
export const X2 = 'x2';
export const Y1 = 'y1';
export const Y2 = 'y2';

// Editable properties

export const PROP_ACTION_APPLY = 'prop_action_apply';
export const PROP_ACTION_CANCEL = 'prop_action_cancel';
export const PROP_ACTION_CROP = 'prop_action_crop';
export const PROP_ACTION_FIT = 'prop_action_fit';
export const PROP_ACTION_RESET = 'prop_action_reset';
export const PROP_ALIGN = 'prop_align';
export const PROP_ANGLE = 'prop_angle';
export const PROP_ARRANGE = 'prop_arrange';
export const PROP_ARROW_1 = 'prop_arrow_1';
export const PROP_ARROW_2 = 'prop_arrow_2';
export const PROP_BLENDING_MODE = 'prop_blending_mode';
export const PROP_BLUR = 'prop_blur';
export const PROP_BORDER_RADIUS = 'prop_border_radius';
export const PROP_BRIGHTNESS = 'prop_brightness';
export const PROP_CHAR_SPACING = 'prop_char_spacing';
export const PROP_CODE_INFO = 'prop_code_info';
export const PROP_CONTRAST = 'prop_contrast';
export const PROP_CROP_POINT = 'prop_crop_point';

export const PROP_FILL = 'prop_fill';
export const PROP_FIT = 'prop_fit';
export const PROP_FLIP = 'prop_flip';
export const PROP_FONT_FAMILY = 'prop_font_family';
export const PROP_FONT_SIZE = 'prop_font_size';
export const PROP_FONT_STYLE = 'prop_font_style';
export const PROP_HEIGHT = 'prop_height';
export const PROP_GROUP = 'prop_group';
export const PROP_IMAGE_SOURCE = 'prop_image_source';
export const PROP_INNER_STROKE = 'prop_inner_stroke';
export const PROP_INVERT_COLORS = 'prop_invert_colors';
export const PROP_LEFT = 'prop_left';
export const PROP_LENGTH = 'prop_length';
export const PROP_LOCK = 'prop_lock';
export const PROP_LINE_HEIGHT = 'prop_line_height';
export const PROP_LIST = 'prop_list';
export const PROP_SPACE_AFTER_PARAGRAPH = 'prop_space_after_paragraph';
export const PROP_OPACITY = 'prop_opacity';
export const PROP_POINT_1 = 'prop_point_1';
export const PROP_POINT_2 = 'prop_point_2';
export const PROP_RICH_INFO = 'prop_rich_info';
export const PROP_SATURATION = 'prop_saturation';
export const PROP_SCALE = 'prop_scale';
export const PROP_SCALE_X = 'prop_scale_x';
export const PROP_SCALE_Y = 'prop_scale_y';
export const PROP_SKEW_X = 'prop_skew_x';
export const PROP_SKEW_Y = 'prop_skew_y';
export const PROP_SHADOW = 'prop_shadow';
export const PROP_SHADOW_BLUR = 'prop_shadow_blur';
export const PROP_SHADOW_OFFSET_X = 'prop_shadow_offset_x';
export const PROP_SHADOW_OFFSET_Y = 'prop_shadow_offset_y';
export const PROP_SPECIAL_ADAPTATIVE_SCALE = 'prop_special_adaptative_scale';
export const PROP_SPECIAL_AUTOPLAY = 'prop_special_autoplay';
export const PROP_SPECIAL_AUTOSPIN = 'prop_special_autospin';
export const PROP_SPECIAL_BACKGROUND_OPACITY =
  'prop_special_background_opacity';
export const PROP_SPECIAL_CAMERA = 'prop_special_camera';
export const PROP_SPECIAL_CONTROLS = 'prop_special_controls';
export const PROP_SPECIAL_DEFAULT_TAB = 'prop_special_default_tab';
export const PROP_SPECIAL_DELAY = 'prop_special_delay';
export const PROP_SPECIAL_END_TIME = 'prop_special_end_time';
export const PROP_SPECIAL_HIDE_FOOTER = 'prop_special_hide_footer';
export const PROP_SPECIAL_HIDE_HEADERS = 'prop_special_hide_headers';
export const PROP_SPECIAL_HIGH_QUALITY = 'prop_special_high_quality';
export const PROP_SPECIAL_HYPERLINK = 'prop_special_hyperlink';
export const PROP_SPECIAL_LOOP = 'prop_special_loop';
export const PROP_SPECIAL_MAP_TYPE = 'prop_special_map_type';
export const PROP_SPECIAL_MUTE = 'prop_special_mute';
export const PROP_SPECIAL_TEMPLATE_REFERENCE =
  'prop_special_template_reference';
export const PROP_SPECIAL_REVERSE = 'prop_special_reverse';
export const PROP_SPECIAL_SPEED = 'prop_special_speed';
export const PROP_BRUSH_SIZE = 'prop_brush_size';
export const PROP_SPECIAL_START_TIME = 'prop_special_start_time';
export const PROP_SPECIAL_THEME = 'prop_special_theme';
export const PROP_SPECIAL_TRANSPARENT = 'prop_special_transparent';
export const PROP_SPECIAL_URL = 'prop_special_url';
export const PROP_SPECIAL_ZOOM = 'prop_special_zoom';
export const PROP_STROKE = 'prop_stroke';
export const PROP_STROKE_DASH = 'prop_stroke_dash';
export const PROP_TEXT_ALIGN = 'prop_text_align';
export const PROP_TEXT_FILL = 'prop_text_fill';
export const PROP_ARROWSIZE = 'prop_arrowSize';
export const PROP_TINT = 'prop_tint';
export const PROP_TOP = 'prop_top';
export const PROP_VERTICAL_ALIGN = 'prop_vertical_align';
export const PROP_WIDTH = 'prop_width';

export const PROP_SPACER = 'prop_spacer';
export const PROP_PLACEHOLDER = 'prop_placeholder';
export const PROP_CHART_INFO = 'prop_chart_info';
